module.exports = __webpack_public_path__ + "img/druzstevne_byvanie.f93cd233.svg";